import React, { useState, useEffect } from "react";
import { GlobalStyle } from "./styledComponents";
import themeContext from "./themeContext/themeContext";
import Home from "./components/Home";
import ProgressBar from "./ProgressBar";

function App() {
  const [isDarkMode, setToggleDarkMode] = useState(true);
  const [isLoading, setIsLoading] = useState(true); // New state for loading indicator
  const [loadingProgress, setLoadingProgress] = useState(0); // State to track loading progress

  useEffect(() => {
    const localStorageValue = JSON.parse(localStorage.getItem("isDarkMode"));

    if (localStorageValue !== null && localStorageValue !== isDarkMode) {
      setToggleDarkMode(localStorageValue);
    }

    const calculateProgress = () => {
      if (document.readyState === "complete") {
        setLoadingProgress(100); // Set progress to 100% when page is fully loaded
        setTimeout(() => {
          setIsLoading(false); // Set isLoading to false after a short delay
        }, 500);
      } else {
        const startTime = window.performance.timing.navigationStart;
        const endTime = Date.now();
        const totalTime = endTime - startTime;
        const progress = (totalTime / 5000) * 100; // Assuming the page should fully load within 5 seconds
        setLoadingProgress(Math.min(progress, 100)); // Cap progress at 100%
      }
    };

    window.addEventListener("load", calculateProgress); // Listen for page load event
    calculateProgress(); // Calculate progress immediately

    return () => window.removeEventListener("load", calculateProgress); // Cleanup event listener
  }, [isDarkMode]);

  const toggleDarkMode = () => {
    localStorage.setItem("isDarkMode", JSON.stringify(!isDarkMode));
    setToggleDarkMode((prevDarkMode) => !prevDarkMode);
  };

  return (
    <themeContext.Provider
      value={{ isDarkMode, onToggleDarkMode: toggleDarkMode }}
    >
      <GlobalStyle isDarkMode={isDarkMode} />
      <ProgressBar progress={loadingProgress} />
      {!isLoading && <Home />}
    </themeContext.Provider>
  );
}

export default App;
